import React from 'react'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'

import AlertBox from './alertBox'

const AlertsStream = ({alerts = [], hideAlert}) => {
  return (
    <div className='grid-container'>
      <CSSTransitionGroup
        transitionName={{
          enter: '-animate--enter',
          enterActive: '-animate--enter-active',
          leave: '-animate--leave',
          leaveActive: '-animate--leave-active'
        }}
        transitionEnterTimeout={500}
        transitionLeaveTimeout={300}>
        {alerts.map(({message, type, canBeDismissed}, index) => {
          if (canBeDismissed) {
            return <AlertBox key={index} type={type} onDismiss={hideAlert.bind(null, message)}>{message}</AlertBox>
          } else {
            return <AlertBox key={index} type={type}>{message}</AlertBox>
          }
        })}
      </CSSTransitionGroup>
    </div>
  )
}

export default AlertsStream



// WEBPACK FOOTER //
// ./client/components/alerts/alertsStream.js